module.exports = __webpack_public_path__ + "static/media/aicpa-logo.8f37d868.png";